// extracted by mini-css-extract-plugin
export default {"createShowcaseContainer":"styles_createShowcaseContainer__-2sM3","showcaseStep":"styles_showcaseStep__GjGyH","footerButtons":"styles_footerButtons__+pxb5"};